module.exports = __webpack_public_path__ + "img/page-manage.e8ab99a8.svg";